<img alt="" src="{{isChecked ? '/assets/images/radio_chacked_icon.svg' : '/assets/images/radio_empty_icon.svg'}}"
     [ngClass]="{'cursor-not-allowed': deliveryDisabled}"
     (click)="deliveryChanged()" class="cursor-pointer">
